import { render, staticRenderFns } from "./configAddScene.vue?vue&type=template&id=0833cb16&"
import script from "./configAddScene.vue?vue&type=script&lang=js&"
export * from "./configAddScene.vue?vue&type=script&lang=js&"
import style0 from "./configAddScene.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports